import { SET_EVENT_DATA } from '../actions/types';

export default function eventDetailsReducer(state = {}, action) {
	switch (action.type) {
		case SET_EVENT_DATA:
			return {
				...state,
				eventData: action.payload.error ? null : action.payload,
				error: action.payload.error || null
			};
		default:
			return state;
	}
}
